import { Form, Picker, Input, Selector, Toast, Uploader, Button, FormInstance } from 'react-vant';
import { publishTypeMap } from '@/pages/ServicesMore/config';
import styles from './index.less';
// import StickyActiveButton from '@/components/StickyActiveButton';
import { useSafeState } from 'ahooks';
import SelectHouseTag from '@/pages/ServicesMore/HouseRentAndSale/components/SelectHouseTag';
import { useModel } from '@umijs/max';
import { useEffect, useRef, useState } from 'react';
import { addWechatRent, getWechatRentDetail, queryCommonUpload, updateWechatRent } from '@/service/rentHouse';
import { useLocation } from '@umijs/max';

const PublishSent = () => {
  const [form] = Form.useForm();
  const [tagData, setTagData] = useState({})
  const [defaultTagData, setDefaultTagData] = useState({})
  const [detailData, setDetailData] = useState({
    sequenceNbr: ''
  })
  const { defaultRoom, ownerInformation } = useModel(
    'useDefaultRoom',
    (model) => ({
      queryInformation: model.queryInformation,
      defaultRoom: model.defaultRoom,
      ownerInformation: model.ownerInformation
    }),
  );
  console.log('eiwf', ownerInformation)

  const location = useLocation();
  const data = new URLSearchParams(location.search).get('sequenceNbr');
 
  const formRef = useRef<FormInstance>(null);

  
  useEffect( () => {
    if (location && data) {
      const fetchData = async () => {
        try {
          await getWechatRentDetail(data).then(res => {
            if (res && res.code === 200) {
              const data = res.data;
              setDetailData(res.data)
              data.rentType = data.rentType ? [data.rentType] : []
              
              if (data.type === '1') {
                data.publishType = '售房'
              } else if (data.type === '2') {
                data.publishType = '租房'
              } else {
                data.publishType = ''
              }
             
              data.urlPath = data.urlPath ? data.urlPath.split(',').map((item: any) => {
                return {
                  url: item.indexOf('http')> -1 || item.indexOf('https')> -1 ? item : window.location.origin + item
                }
              }) : []

              formRef.current?.setFieldsValue(data)

              const defaultTag = {
                roomType: data.roomType ? [data.roomType] : [],
                facing: data.facing ? [data.facing] : [],
                decoration: data.decoration ? [data.decoration] : [],
                layout: data.layout ? [data.layout] : [],
                floor: data.floor ? [data.floor] : [],
              }

              console.log(8888888, defaultTag)
              setDefaultTagData(defaultTag)
              onSuccess(defaultTag)
             
            }
          })
        } catch (error) {
          console.error('获取数据失败:', error);
        } finally {
      };
    }
      fetchData()
    }
  }, [])
  const [selectTagVisible, setSelectTagVisible] = useSafeState<boolean>(false);

  const communityPickerData = [{
    text: defaultRoom?.communityName,
    value: defaultRoom?.communityId,
  }];
  const onFinish = async (values: any) => {
    console.log(values)
   
    if (Object.keys(tagData).length === 0) {
      Toast('请选择标签信息！')
      return
    }
    const formData = new FormData();
    const uploadedList: any[] = []
    const unloadedList: any[] = []
    values.urlPath && values.urlPath.map((file: any) => {
      if (file.file) {
        unloadedList.push(file)
      } else {
        uploadedList.push(file)
      }
      
    });
    const params = {...values, ...tagData}
    console.log(params)
  
    if (unloadedList.length) {
      unloadedList.map((file: any) => {
        formData.append('files', file.file);
      })
      await queryCommonUpload(formData).then(res => {
        if (res?.code === 200) {
          const urls = res?.fileNames;
         const images = (uploadedList || []).map((item: any) => {
          let origin = window.location.origin; 
          let pathWithoutOrigin = item.url.replace(origin, '');
            // 获取去掉origin的部分，并确保路径以斜杠开始（如果有需要的话）
          return pathWithoutOrigin
         } )
          params.urlPath = images.length ? images?.join(',') +',' + urls : urls 
          console.log(99, images, urls)
        }
      });
    } else {
      const images = (uploadedList || []).map((item: any) => {
        let origin = window.location.origin; 
        let pathWithoutOrigin = item.url.replace(origin, '');
          // 获取去掉origin的部分，并确保路径以斜杠开始（如果有需要的话）
        return pathWithoutOrigin
       } )
        params.urlPath = images.length ? images?.join(','): ''
    }

    console.log(99, params.urlPath)
    if (params.publishType === '售房') {
      params.type = '1'
    }

    if (params.publishType === '租房') {
      params.type = '2'
    }
    params.rentType = params.rentType && params.rentType.length && params.rentType[0] || ''
    params.communityName = defaultRoom?.communityName
    params.createBy = ownerInformation?.nickName;
    if (detailData && detailData?.sequenceNbr) {
      params.sequenceNbr = detailData?.sequenceNbr
      updateWechatRent(params).then(res => {
        if (res && res.code ===200) {
          Toast.success('修改更新成功')
          history.back()
        }
      })
    } else {
      addWechatRent(params).then(res => {
        if (res && res.code ===200) {
          Toast.success('新增成功')
          history.back()
        }
      })
    }
    
  };

  

  const onSuccess = (values: any) => {
    const obj = {
      roomType: '',
      facing: '',
      decoration: '',
      layout: '',
      floor: ''
    }
    for (let key in values) {
      if (values.hasOwnProperty(key)) {
        console.log(key, values[key]);
        obj[key as keyof typeof obj] = values[key] && values[key].length && values[key][0] || '';
      }
    }

    setTagData(obj)
    setSelectTagVisible(false)

  }

  const submitPicture = (values: any) => {
    console.log(values)
    if (!values.length) {
      return
    }
   
  }

  return (
    <div className={styles.container}>
      <Form className={styles.form} ref={formRef} form={form} onFinish={onFinish}
        footer={
        <div className={styles.buttonBox}>
          <Button round nativeType='submit' type='primary' block>
            提交
          </Button>
        </div>
      }>
        <Form.Item
          label={'发布类型'}
          name={'publishType'}
          isLink
          trigger={'onConfirm'}
          rules={[{ required: true, message: '请选择' }]}
          onClick={(_, action) => {
            console.log(action?.current, 'action');
            action?.current?.open();
          }}
        >
          <Picker popup columns={Object.values(publishTypeMap)}>
            {(value) => value || '请选择发布类型'}
          </Picker>
        </Form.Item>
        <Form.Item
          isLink
          trigger={'onConfirm'}
          rules={[{ required: true, message: '请选择' }]}
          onClick={(_, action) => {
            action?.current?.open();
          }}
          label={'选择小区'}
          name={'communityId'}
        >
          <Picker title={'选择小区'} columns={communityPickerData} popup>
            {(value) =>
              value
                ? communityPickerData.find((item) => item?.value === value)
                    ?.text
                : '' || '选择'
            }
          </Picker>
        </Form.Item>
        <Form.Item required label={'发布标题'} name={'title'} rules={[{ required: true, message: '请填写' }]}>
          <Input placeholder={'请输入标题'} />
        </Form.Item>
        <Form.Item required label={'详细地址'} name={'address'} rules={[{ required: true, message: '请填写' }]}>
          <Input.TextArea placeholder={'请输入详细地址'} />
        </Form.Item>
        <Form.Item required label={'租售类别'} name={'rentType'} rules={[{ required: true, message: '请选择' }]}>
          <Selector 
            options={[
              { label: '整租', value: '整租' },
              { label: '合租', value: '合租' },
              { label: '出售', value: '出售' },
            ]}
            
          />
        </Form.Item>
        <Form.Item label={'租金/售价'} name={'price'} rules={[{ required: true, message: '请填写' }]}>
          <Input type={'number'} placeholder={'请输入租金/售价'} />
        </Form.Item>
        <Form.Item label={'房屋面积'} name={'area'} rules={[{ required: true, message: '请填写' }]}>
          <Input type={'number'} placeholder={'请输入房屋面积'} />
        </Form.Item>
        <Form.Item label={'房屋年限'} name={'duration'} rules={[{ required: true, message: '请填写' }]}>
          <Input type={'number'} placeholder={'请输入房屋年限'} />
        </Form.Item>
        {/* <Form.Item label={'联系人'} name={'area'}>
          <Input placeholder={'请输入联系人'} />
        </Form.Item> */}
        <Form.Item label={'联系电话'} name={'phone'} rules={[{ required: true, message: '请填写' }, {
                  pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
                  message: '请输入正确的手机号码',
                }]}>
          <Input type={'tel'} placeholder={'请输入联系电话'} />
        </Form.Item>
        <Form.Item
          label={'选择标签'}
          isLink
          onClick={() => {
            setSelectTagVisible(true);
          }}
        >
          <SelectHouseTag
            visible={selectTagVisible}
            onSuccess={onSuccess}
            defaultData={defaultTagData}
            onClose={() => setSelectTagVisible(false)}
          />
        </Form.Item>
        <Form.Item label={'房源描述'} name={'content'} rules={[{ required: true, message: '请填写' }]}>
          <Input.TextArea placeholder={'请输入房源描述'} />
        </Form.Item>
        <Form.Item label={'房源图片'} name={'urlPath'}>
          <Uploader
            maxCount={3}
            maxSize={5 * 1024 * 1024}
            onOversize={() => Toast.info('文件大小不能超过5M')}
            onChange={v => submitPicture(v)}
          />
        </Form.Item>
      </Form>
      
      {/* <StickyActiveButton activeText={'提交22'} activeClick={onFinish} /> */}
    </div>
  );
};

export default PublishSent;
